<div class="modalHolder" style="display: none;">
	<div id="modalSetup" class="modal modalLarge">
		<div class="modalAlignHolder">
			<div class="align bgWhite">
				<header class="modalHeader">
					<h1><span class="icon-settings modalHeaderIcon"><span class="srOnly">settings</span></span> Setup</h1>
					<a href="#" class="modalBtnClose icon-cross"><span class="srOnly">close</span></a>
				</header>
				<form action="#" class="modalForm">
					<ul class="modalTabList textCenter listUnstyled textCapatalize">
						<li class="active"><a href="#">Main</a></li>
						<li><a href="#">Object groups</a></li>
						<li><a href="#">Drivers</a></li>
						<li><a href="#">Events</a></li>
						<li><a href="#">SMS gateway</a></li>
						<li><a href="#">SMS templates</a></li>
						<li><a href="#">GPRS templates</a></li>
						<li><a href="#">Widgets</a></li>
					</ul>
					<div class="modalTabContent">
						<div id="modalTabMain" class="hidden">
							<div class="modalContentWrap">
								<div class="formGroup">
									<label for="Unitofdistance" class="elementBlock">Unit of distance:</label>
									<select id="Unitofdistance" class="formControlDefault">
										<option>Kilometer</option>
										<option>Kilometer</option>
										<option>Kilometer</option>
										<option>Kilometer</option>
									</select>
								</div>
								<div class="formGroup">
									<label for="Unitofcapacity" class="elementBlock">Unit of capacity:</label>
									<select id="Unitofcapacity" class="formControlDefault">
										<option>Liter</option>
										<option>Liter</option>
										<option>Liter</option>
										<option>Liter</option>
									</select>
								</div>
								<div class="formGroup">
									<label for="Unitofaltitude" class="elementBlock">Unit of altitude:</label>
									<select id="Unitofaltitude" class="formControlDefault">
										<option>Meter</option>
										<option>Meter</option>
										<option>Meter</option>
										<option>Meter</option>
									</select>
								</div>
								<div class="formGroup">
									<label for="startday" class="elementBlock">Default calendar week start day:</label>
									<select id="startday" class="formControlDefault">
										<option>Monday</option>
										<option>Monday</option>
										<option>Monday</option>
										<option>Monday</option>
									</select>
								</div>
								<div class="formGroup">
									<label for="Timezone" class="elementBlock">Timezone:</label>
									<select id="Timezone" class="formControlDefault">
										<option>UTC 00:00</option>
										<option>UTC 00:00</option>
										<option>UTC 00:00</option>
										<option>UTC 00:00</option>
									</select>
								</div>
								<hr class="modalSeparator elementBlock">
								<strong class="h4 elementBlock">Daylight saving time</strong>
								<div class="formGroup">
									<label for="Type" class="elementBlock">Type:</label>
									<select id="Type" class="formControlDefault">
										<option>None</option>
										<option>None</option>
										<option>None</option>
										<option>None</option>
									</select>
								</div>
							</div>
							<footer class="modalFooter">
								<a href="#" class="btn btnDefault">save</a>
								<a href="#" class="btn btnPrimary">cancel</a>
							</footer>
						</div>
						<div id="modalTabObjectGroups">
							<div class="modalContentWrap">
								<div class="formGroup">
									<label for="newMobicel" class="srOnly">newMobicel</label>
									<button class="fieldRemover icon-cross" type="button"><span class="srOnly">remove</span></button>
									<input type="text" id="newMobicel" class="formControl elementBlock" value="newMobicel">
								</div>
								<div class="formGroup">
									<label for="call" class="srOnly">call</label>
									<button class="fieldRemover icon-cross" type="button"><span class="srOnly">remove</span></button>
									<input type="tel" id="call" class="formControl elementBlock" value="027044903292">
								</div>
								<div class="formGroup">
									<label for="8ui6782" class="srOnly">8ui678</label>
									<button class="fieldRemover icon-cross" type="button"><span class="srOnly">remove</span></button>
									<input type="tel" id="8ui6782" class="formControl elementBlock" value="8ui678">
								</div>
								<div class="formGroup">
									<label for="newMobicel2" class="srOnly">newMobicel</label>
									<button class="fieldRemover icon-cross" type="button"><span class="srOnly">remove</span></button>
									<input type="text" id="newMobicel2" class="formControl elementBlock" value="newMobicel">
								</div>
								<div class="formGroup">
									<label for="call3" class="srOnly">call</label>
									<button class="fieldRemover icon-cross" type="button"><span class="srOnly">remove</span></button>
									<input type="tel" id="call3" class="formControl elementBlock" value="027044903292">
								</div>
								<div class="formGroup">
									<label for="8ui6784" class="srOnly">8ui678</label>
									<button class="fieldRemover icon-cross" type="button"><span class="srOnly">remove</span></button>
									<input type="tel" id="8ui6784" class="formControl elementBlock" value="8ui678">
								</div>
							</div>
							<footer class="modalFooter">
								<a href="#" class="btn btnDefault">save</a>
								<a href="#" class="btn btnPrimary">cancel</a>
							</footer>
						</div>
						<div id="modalTabDrivers" class="hidden">
							<div class="modalContentWrap">
								<div class="modalTableWrap">
									<div class="textRight">
										<button type="button" class="btn btnDefault btnEnterFiled"><span class="icon-plus btnIcon"><span class="srOnly">add</span></span>add driver</button>
									</div>
									<table class="modalDataTable">
										<thead>
										<tr>
											<th>name</th>
											<th>device</th>
											<th>RFID</th>
											<th>phone</th>
											<th>email</th>
											<th>description</th>
											<th>&nbsp;</th>
										</tr>
										</thead>
										<tbody>
										<tr>
											<td>Base</td>
											<td>Ford Transit</td>
											<td>&nbsp;</td>
											<td><a href="tel:8703706080">8703706080</a></td>
											<td><a href="mailto:&#069;&#108;&#108;&#105;&#115;&#106;&#097;&#115;&#111;&#110;&#049;&#053;&#049;&#064;&#103;&#109;&#097;&#105;&#108;">&#069;&#108;&#108;&#105;&#115;&#106;&#097;&#115;&#111;&#110;&#049;&#053;&#049;&#064;&#103;&#109;&#097;&#105;&#108;</a></td>
											<td>&nbsp;</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>Joe</td>
											<td>&nbsp;</td>
											<td>###33</td>
											<td><a href="tel:8703706080">8703706080</a></td>
											<td>&nbsp;</td>
											<td>Mano</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>Base</td>
											<td>Ford Transit</td>
											<td>&nbsp;</td>
											<td><a href="tel:8703706080">8703706080</a></td>
											<td><a href="mailto:&#069;&#108;&#108;&#105;&#115;&#106;&#097;&#115;&#111;&#110;&#049;&#053;&#049;&#064;&#103;&#109;&#097;&#105;&#108;">&#069;&#108;&#108;&#105;&#115;&#106;&#097;&#115;&#111;&#110;&#049;&#053;&#049;&#064;&#103;&#109;&#097;&#105;&#108;</a></td>
											<td>&nbsp;</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>Joe</td>
											<td>Ford Transit</td>
											<td>####</td>
											<td><a href="tel:8703706080">8703706080</a></td>
											<td>&nbsp;</td>
											<td>Mano</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
							<footer class="modalFooter">
								<a href="#" class="btn btnDefault">save</a>
								<a href="#" class="btn btnPrimary">cancel</a>
							</footer>
						</div>
						<div id="modalTabEvents" class="hidden">
							<div class="modalContentWrap">
								<div class="modalTableWrap">
									<div class="textRight">
										<button type="button" class="btn btnDefault btnEnterFiled"><span class="icon-plus btnIcon"><span class="srOnly">add</span></span>add event</button>
									</div>
									<table class="modalDataTable">
										<thead>
										<tr>
											<th>title</th>
											<th>parameters</th>
											<th>message</th>
											<th>show always</th>
											<th>&nbsp;</th>
										</tr>
										</thead>
										<tbody>
										<tr>
											<td>upro</td>
											<td>speed</td>
											<td>speed over 10</td>
											<td>yes</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>upro</td>
											<td>speed</td>
											<td>speed over 10</td>
											<td>yes</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>upro</td>
											<td>speed</td>
											<td>speed over 10</td>
											<td>yes</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>upro</td>
											<td>speed</td>
											<td>speed over 10</td>
											<td>yes</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>upro</td>
											<td>speed</td>
											<td>speed over 10</td>
											<td>yes</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>upro</td>
											<td>speed</td>
											<td>speed over 10</td>
											<td>yes</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
							<footer class="modalFooter">
								<a href="#" class="btn btnDefault">save</a>
								<a href="#" class="btn btnPrimary">cancel</a>
							</footer>
						</div>
						<div id="modalTabSMSTemplates" class="hidden">
							<div class="modalContentWrap">
								<div class="modalTableWrap">
									<div class="textRight">
										<button type="button" class="btn btnDefault btnEnterFiled"><span class="icon-plus btnIcon"><span class="srOnly">add</span></span>add templates</button>
									</div>
									<table class="modalDataTable">
										<thead>
										<tr>
											<th>title</th>
											<th>&nbsp;</th>
										</tr>
										</thead>
										<tbody>
										<tr>
											<td>20</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>20</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>20</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>20</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>20</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>20</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>20</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>20</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div id="modalTabGPRSTemplates" class="hidden">
							<div class="modalContentWrap">
								<div class="modalTableWrap">
									<div class="textRight">
										<button type="button" class="btn btnDefault btnEnterFiled"><span class="icon-plus btnIcon"><span class="srOnly">add</span></span>add event</button>
									</div>
									<table class="modalDataTable">
										<thead>
										<tr>
											<th>title</th>
											<th>&nbsp;</th>
										</tr>
										</thead>
										<tbody>
										<tr>
											<td>Speedy.com.bd</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>Speedy.com.bd</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>Speedy.com.bd</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>Speedy.com.bd</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>Speedy.com.bd</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>Speedy.com.bd</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>Speedy.com.bd</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										<tr>
											<td>Speedy.com.bd</td>
											<td class="textRight">
												<button type="button" class="icon-settings2 btn"><span class="srOnly">setting</span></button>
												<button type="button" class="icon-cross btn"><span class="srOnly">delete</span></button>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>